import { Button, Center, Divider, Image, Paper, Stack, Text } from '@mantine/core';

import config from '@/config';

type ServerErrorProps = {
  onRetry: () => void;
  isFetching: boolean;
};

export const ServerError = ({ onRetry, isFetching }: ServerErrorProps) => {
  return (
    <Center h="100vh">
      <Paper style={{ width: '350px' }} radius="md" p="xl" withBorder>
        <Image h={30} fit="contain" src={config.brand.logo} alt="logo" />
        <Divider my="lg" />
        <Stack align="center" gap="md">
          <Text size="sm" c="dimmed" ta="center">
            Ошибка соединения с сервером
          </Text>
          <Text size="xs" c="dimmed" ta="center">
            Попробуйте повторить попытку или свяжитесь с командой поддержки
          </Text>
          <Button onClick={onRetry} loading={isFetching}>
            Повторить
          </Button>
        </Stack>
      </Paper>
    </Center>
  );
};
